export default __webpack_public_path__ + "static/media/altere.4fe7fb9f.svg";